import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.catalogos.sepomex = {
      ...state.app.catalogos.sepomex,
      filters: {
        ...state.app.catalogos.sepomex.filters,
        ...meta,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.catalogos.sepomex;

    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      page: meta.page || 1,
    };

    const response = await Http.get('catalogos/custom-address-comercio-exterior', { params });

    store.setState((state) => {
      state.app.catalogos.sepomex = {
        ...state.app.catalogos.sepomex,
        busy: false,
        data: response.data,
        pagination: {
          ...state.app.catalogos.sepomex.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.catalogos.sepomex.busy = false;
      state.app.catalogos.sepomex.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.catalogos.sepomex = {
      ...initialState,
    };
  });
};

const SepomexCodigoPostalSuggestionsStore = {
  state: () => initialState,
  actions: {
    paginate,
    reset,
  },
};

export default SepomexCodigoPostalSuggestionsStore;
